module.exports = __webpack_public_path__ + "static/img/productu03.1320339f.png";